import { Table } from '@dixa/lib-shared-habla';

export function EmptyRow(): JSX.Element {
  return (
    <Table.Tr>
      <Table.Td colSpan={3}>No widgets found.</Table.Td>
    </Table.Tr>
  );
}
